import exp from "constants";
import React from "react";
const PostSkeleton = ({ count = 1 }: { count?: number }) => (
  <div className="space-y-6">
    {Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        className="bg-white rounded-2xl border border-gray-200 p-4 animate-pulse"
      >
        <div className="flex gap-3">
          <div className="w-12 h-12 rounded-full bg-gray-300" />
          <div className="space-y-2 flex-1">
            <div className="h-5 bg-gray-300 rounded w-40" />
            <div className="h-4 bg-gray-200 rounded w-24" />
          </div>
        </div>
        <div className="mt-4 space-y-3">
          <div className="h-4 bg-gray-200 rounded" />
          <div className="h-4 bg-gray-200 rounded w-11/12" />
          <div className="h-4 bg-gray-200 rounded w-9/12" />
        </div>
      </div>
    ))}
  </div>
);

export default PostSkeleton;
